module.exports = __webpack_public_path__ + "static/media/github-workshop.99631d92.jpeg";